module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_3-6eb664488e3116cf9a89b0fb1e256de5.png";